<script>
import ButtonIcon from "@/components/molecules/button-icon";
import Popin from "@/containers/popin-adaptive";
import Icon from "@/components/atoms/icon";

export default {
  name: "FideliteCarteInfo",
  components: {
    Popin,
    Icon,
    ButtonIcon
  }
};
</script>

<template>
  <div>
    <Popin
      ref="showPopinInfos"
      slide-up
      size="md"
    >
      <div class="u-flex u-flex-column">
        <Icon
          name="info-circle-outline"
          variant="primary"
          size="lg"
          class="u-flex-self-center u-mb-sm"
        />
        <slot />
      </div>
    </Popin>

    <ButtonIcon
      icon-name="info"
      icon-color="primary"
      variant="primary"
      icon-size="xs"
      outline
      class="u-radius-full u-ml-xxs"
      @click="$refs.showPopinInfos.show()"
    />
  </div>
</template>
